module.exports = __webpack_public_path__ + "static/media/st_details_edit_station.0bf2e097.svg";